import React from 'react'
import { cerealesColor } from '../../../../config/cereales'
import { COLORES } from '../../../../config/colores'

const CalendarioControles = (props) => {
  const { selectedCereales, onCerealFilter, cargasAnunciadas, cereales } = props

  const toggleCereal = (cereal) => {
    let newSelectedCereals

    if (selectedCereales.includes(cereal)) {
      newSelectedCereals = selectedCereales.filter((c) => c !== cereal)

      if (newSelectedCereals.length === 0) {
        newSelectedCereals = [cereal]
      }
    } else {
      newSelectedCereals = [...selectedCereales, cereal]
    }
    onCerealFilter(newSelectedCereals)
  }

  const selectAllCereals = () => {
    onCerealFilter(cereales && cereales.map((c) => c))
  }

  const getCerealCount = (cerealName) => {
    return cargasAnunciadas.filter((carga) => carga.claveCereal.trim() === cerealName.trim()).length
  }

  return (
    <div className='calendar-controls'>
      <div className='controls-row'>

        {/* Filtros individuales */}
        <div className='cereal-filters'>
          <button
            className='quick-button'
            onClick={selectAllCereals}
            style={{ visibility: (selectedCereales.length === cereales.length) ? 'hidden' : 'visible' }}
            disabled={selectedCereales.length === cereales.length}
          >
              Todos
          </button>
          {cereales && cereales.map((cereal) => {
            const isSelected = selectedCereales.includes(cereal)
            const count = getCerealCount(cereal)

            return (
              <button
                key={cereal}
                className={`cereal-filter ${isSelected ? 'selected' : 'unselected'}`}
                onClick={() => toggleCereal(cereal)}
                style={{
                  backgroundColor: isSelected ? COLORES.grey.dark : 'transparent',
                  borderColor: COLORES.grey.dark,
                  color: isSelected ? 'white' : COLORES.grey.mediumDark
                }}
              >
                <div className='cereal-dot' style={{ backgroundColor: cerealesColor[cereal] }} />
                <span>{cereal}</span>
                <span className='cereal-count'>{count}</span>
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default CalendarioControles
